import * as React from 'react';

import classNames from 'classnames';

import type {CouponFragment} from 'nutshell-graphql-types';

import {Body} from '../../typography/body';

import {CouponPill} from './coupon-pill';

import styles from './billing-summary.module.css';

type Props = {
    description: string;
    tier?: string | null | undefined;
    detail?: string | null | undefined;
    coupons?: CouponFragment[];
    customRow?: React.ReactNode | null | undefined;
    isBold?: boolean;
    leftBorder?: boolean;
};

export function DescriptionCell(props: Props) {
    const containerClassName = classNames(styles['description-cell-container'], {
        [styles['left-border']]: props.leftBorder,
    });

    return (
        <td>
            <div className={containerClassName}>
                <Body as='div' size='large'>
                    {props.isBold ? <b>{props.description}</b> : props.description}{' '}
                    {props.tier && `${props.tier}`}
                </Body>
                {props.detail && (
                    <Body as='div' color='light' size='small'>
                        {props.detail}
                    </Body>
                )}
                {props.coupons &&
                    props.coupons.map((coupon) => {
                        return <CouponPill key={coupon.code} coupon={coupon} />;
                    })}
                {props.customRow}
            </div>
        </td>
    );
}
